import React, { useState, useEffect } from 'react';
import Button from '@/shared/components/UI/Button';
import Modal from '@/v3-dashboard/components/UI/Modal';

const DConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  onLeaveWithoutSaving,
  title,
  description: descriptionProp,
  confirmText,
  cancelText,
  leaveWithoutSavingText,
  variantConfirm,
  loading = false,
  closeBackdrop = true,
}) => {
  const [description, setDescription] = useState(descriptionProp);

  useEffect(() => {
    if (open && descriptionProp) {
      setDescription(descriptionProp);
    }
  }, [open, descriptionProp]);

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title={title}
      closeBackdrop={closeBackdrop}
      className="md:w-[520px]"
      titleClassName="!text-v3-h9 !font-bolder font-inter-variable"
    >
      <>
        <p className="text-lg tracking-tight font-light text-v3-h9 mb-0 md:mb-v3-md">{description}</p>
        <footer className="flex flex-col w-full gap-v3-sm md:gap-v3-xs mt-auto md:flex-row md:items-center md:justify-between md:gap-v3-xs md:mt-0 border-grey-5">
          <Button
            onClick={onClose}
            size="lg"
            variant="secondary"
            label={cancelText}
            className="w-full justify-center md:w-auto md:justify-start"
          />
         <div className='flex flex-col w-full gap-v3-sm md:gap-v3-xs md:flex-row md:w-auto md:items-center md:gap-v3-xs'>
            {leaveWithoutSavingText && (
              <Button
                onClick={onLeaveWithoutSaving || onConfirm}
                size="lg"
                variant="danger-secondary"
                loading={loading}
                label={leaveWithoutSavingText}
                className="w-full justify-center md:w-auto md:justify-start"
              />
            )}
           <Button
            onClick={onConfirm}
            variant={variantConfirm || 'primary'}
            size="lg"
            loading={loading}
            label={confirmText}
            className="w-full justify-center md:w-auto md:justify-start"
          />
         </div>
        </footer>
      </>
    </Modal>
  );
};

export default DConfirmationModal;
